"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function GdriveMultitoneGreyFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M1.374 13.149l.687 1.19c.128.226.312.41.523.55.035.023.082.012.105-.027l2.42-4.188H.206c-.004 0-.012.004-.012.012 0 .273.074.546.215.796l.964 1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M8 5.663L5.55 1.421c-.004-.007-.012-.007-.02-.003-.234.14-.437.335-.578.581L.41 9.866a1.63 1.63 0 00-.215.734c0 .04.032.074.07.074h4.847L8 5.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M13.331 14.896c.008.016.031.024.047.012.23-.14.421-.332.558-.573l.285-.492 1.37-2.369c.14-.246.21-.515.214-.788 0-.008-.008-.016-.015-.016h-4.902l2.443 4.226zM8 5.663l2.455-4.246c.004-.003 0-.011-.004-.015a1.557 1.557 0 00-.796-.21h-3.31a1.68 1.68 0 00-.78.198c-.016.008-.02.024-.012.04L8 5.662zM10.888 10.67H5.112l-2.45 4.246c-.004.008 0 .016.004.02.238.136.51.206.792.206h9.085c.277 0 .55-.078.784-.203.012-.004.012-.02.008-.027l-2.447-4.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M13.319 5.933l-2.271-3.934a1.585 1.585 0 00-.562-.574c-.016-.008-.035-.004-.043.012L8 5.663l2.888 5.007h4.91c0-.277-.071-.554-.216-.804L13.32 5.933z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M2.626 15.092a.272.272 0 01-.144-.043 1.814 1.814 0 01-.59-.617l-1.65-2.856a1.845 1.845 0 01-.242-.89v-.078l.113-.125.094-.004h5.245l-2.592 4.48a.284.284 0 01-.171.129c-.02.004-.04.004-.063.004zm-1.08-2.041l.686 1.19c.09.156.21.293.36.41l2.185-3.782H.406c.027.184.086.355.175.511l.964 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.225 10.865H.27a.262.262 0 01-.19-.082.278.278 0 01-.075-.195c.012-.285.094-.57.238-.82l4.542-7.867c.153-.265.371-.483.648-.651l.07-.043.172.039.05.082 2.506 4.34-3.005 5.197zm-4.82-.39h4.598l2.775-4.812-2.299-3.972c-.148.113-.265.25-.355.406L.578 9.964c-.09.16-.149.332-.172.511zM13.409 15.119l-.106-.016a.238.238 0 01-.144-.109l-2.61-4.519h5.322l.129.129v.094c-.004.3-.086.604-.238.878l-1.655 2.86c-.148.258-.359.472-.624.64l-.074.043zm-2.182-4.254l2.186 3.782c.148-.113.265-.25.355-.41l1.654-2.86c.09-.16.149-.332.176-.512h-4.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8 6.058L5.346 1.46l.02-.101a.206.206 0 01.109-.133c.273-.148.574-.226.87-.226h3.31c.32 0 .628.082.893.234l.172.102-.102.183L8 6.058zM5.814 1.496L8 5.277l2.185-3.785a1.412 1.412 0 00-.53-.102h-3.31c-.175 0-.355.035-.53.106zM12.542 15.338H3.458c-.32 0-.625-.082-.89-.235l-.07-.039-.047-.171.043-.082 2.505-4.336h6.002l2.544 4.406-.043.176-.082.05c-.277.152-.581.23-.878.23zm-9.615-.492c.164.066.343.101.53.101h9.085c.176 0 .36-.035.531-.105l-2.298-3.977h-5.55l-2.298 3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M15.992 10.865h-5.217L7.774 5.663l2.54-4.398.098-.035a.215.215 0 01.175.028c.27.163.48.382.629.643L15.75 9.77c.156.277.242.585.242.901v.195zm-4.991-.39h4.585a1.4 1.4 0 00-.175-.511L10.88 2.097a1.43 1.43 0 00-.359-.41L8.222 5.663l2.779 4.812zm-.386-8.94c-.004 0-.004 0 0 0z"
  }));
}

GdriveMultitoneGreyFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
GdriveMultitoneGreyFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = GdriveMultitoneGreyFilled;
exports["default"] = _default;